import React, { useState, useEffect } from "react";
import { divisionTypes } from "../../../constants/division-types";

const AKHeader = ({
  option,
  handleClick,
  orderKey,
  isAscending,
  disabled,
  disableSorting,
  divisionNameForTheme,
}) => {
  /**
   * Use State Hooks
   */
  const [orderKeyState, setOrderKeyState] = useState();
  const [isAscendingState, setIsAscendingState] = useState();
  const [headerStyle, setHeaderStyle] = useState("");

  /**
   * Use Effect Hooks
   */

  /**
   * Effect to update internal order key state
   */
  useEffect(() => {
    let isMounted = true;

    if (orderKey != null) {
      isMounted && setOrderKeyState(orderKey);
    }

    return () => {
      isMounted = false;
    };
  }, [orderKey]);

  /**
   * Effect to update internal is ascending state
   */
  useEffect(() => {
    let isMounted = true;

    if (isAscending != null) {
      isMounted && setIsAscendingState(isAscending);
    }

    return () => {
      isMounted = false;
    };
  }, [isAscending]);

  /**
   * Effect to update header icon style
   */
  useEffect(() => {
    let isMounted = true;

    if (isAscendingState != null && orderKeyState != null && option) {
      if (orderKeyState === option.key) {
        if (isAscendingState) {
          isMounted && setHeaderStyle("fa fa-caret-down fa-lg");
        } else {
          isMounted && setHeaderStyle("fa fa-caret-up fa-lg");
        }
      } else {
        isMounted && setHeaderStyle("fa fa-caret-right fa-lg");
      }
    }

    return () => {
      isMounted = false;
    };
  }, [isAscendingState, option, orderKeyState]);

  const handleHeaderClick = (event) => {
    event.preventDefault();
    handleClick(option);
  };

  const getHeaderStyle = (noHover) => {
    if (divisionNameForTheme) {
      switch (divisionNameForTheme) {
        case divisionTypes.PAINT:
          return noHover
            ? " header-button-paint-no-hover"
            : " header-button-paint";
        case divisionTypes.CLEAN:
        case divisionTypes.HALLWAY_CLEAN:
          return noHover
            ? " header-button-clean-no-hover"
            : " header-button-clean";
        case divisionTypes.SHAMPOO:
          return noHover
            ? " header-button-shampoo-no-hover"
            : " header-button-shampoo";
        case divisionTypes.ALL:
          return noHover ? " header-button-all-no-hover" : " header-button-all";
        default:
          break;
      }
    } else {
      return "";
    }
  };

  return (
    <>
      {!option ? (
        <div
          className={
            disabled ? "ak-disabled-header" : `${getHeaderStyle(true)}`
          }
        ></div>
      ) : !disableSorting ? (
        option.show && (
          <button
            onClick={handleHeaderClick}
            className={
              disabled ? "ak-disabled-header" : `${getHeaderStyle(false)}`
            }
          >
            {option.header}
            <br />
            <i className={headerStyle} />
          </button>
        )
      ) : (
        option.show && (
          <div
            className={
              disabled ? "ak-disabled-header" : `${getHeaderStyle(true)}`
            }
          >
            {option.header}
          </div>
        )
      )}
    </>
  );
};

export default AKHeader;
